__turbopack_context__.v({
  "formSection": "BlogForm-module-scss-module__4Fia3G__formSection",
  "root": "BlogForm-module-scss-module__4Fia3G__root",
});
